import { Account } from '@/domain/usecases'
import CompanyManagerBaseLoader from '@/main/routes/loaders/company-manager-base-loader'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { QueryClient } from 'react-query'
import PathConstants from '@/main/routes/path-contants'
import { AccountType } from '@/data/usecases/account/account-type'
import { dependentRequestService } from '@/data/services/dependent/dependent-service'

export default class CompanyManagerDependentConfigurationLoader extends CompanyManagerBaseLoader {
  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient,
    readonly ldClient: LDClient | undefined,
    readonly redirectUrl: string = PathConstants.Routes.USER_PROFILE.value
  ) {
    super(account, redirectUrl, queryClient, ldClient)
  }

  async loader() {
    if (!this.verifyPermission(this.account)) {
      return super.notAllowedLoader()
    }

    const [settings] = await Promise.all([
      dependentRequestService.fetchSettings(this.account.company.uniqueId)
    ])

    return this.defer({
      data: {
        data: {
          ...settings,
          plans: settings?.plans || [],
          upgradePlans: settings?.upgradePlans || []
        },
        accountProfile: this.account
      }
    })
  }

  private verifyPermission(account: Account.Model): boolean {
    return AccountType.Enum.COLLABORATOR.is(account) && Account.isCompanyManager(account)
  }
}
